import { Endpoint } from '../../../Endpoint';
import { EndpointsHeader } from '../../../EndpointsHeader';
import { useGRPCEndpointStyles } from './useGRPCEndpointStyles';

interface GRPCEndpointProps {
  url: string;
  xToken: string;
}

const KEYWORD = 'Archive';

export const GRPCEndpoint = ({ url, xToken }: GRPCEndpointProps) => {
  const { classes } = useGRPCEndpointStyles();

  const hasKeyword = url.includes(KEYWORD.toLowerCase());

  return (
    <div className={classes.root}>
      <div className={classes.record}>
        <EndpointsHeader title={hasKeyword ? `${KEYWORD} gRPC` : 'gRPC'} />
        <Endpoint isGRPC url={url} />
      </div>
      <div className={classes.record}>
        <EndpointsHeader title="x-token" />
        <Endpoint prefix="x-token: " url={xToken} />
      </div>
    </div>
  );
};
